import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { CuestionariosService } from '../services/cuestionarios.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-guiones-dialog',
  templateUrl: './guiones-dialog.component.html',
  providers: [MessageService]
})
export class GuionesDialogComponent implements OnInit, OnChanges {
  @Input() displayDialog: boolean = false;
  @Input() preguntaSeleccionada: any = null;
  @Input() cuestionario: any = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean}>();
  @ViewChild('dt') table!: Table;

  loading: boolean = false;
  guiones: any[] = [];
  displayedColumns = [
    { field: 'iNumGuia', header: 'N° Guía' },
    { field: 'sTexto', header: 'Texto' },
    { field: 'sTabla', header: 'Tabla' },
    { field: 'sTipo', header: 'Tipo' },
    { field: 'sCampo', header: 'Campo' },
    { field: 'actions', header: 'Acciones' }
  ];

  displayNuevoGuionDialog: boolean = false;
  guionSeleccionado: any = null;

  constructor(
    private messageService: MessageService,
    private cuestionariosService: CuestionariosService
  ) {}

  ngOnInit(): void {
    this.cargarGuiones();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['displayDialog'] && this.displayDialog) {
      this.cargarGuiones();
    }
  }

  cargarGuiones(): void {
    if (!this.cuestionario || !this.preguntaSeleccionada) return;

    this.loading = true;
    const request = {
      que: 4,
      tope: "999",
      sClaveCues: this.cuestionario.sClaveCues,
      iNumPreg: this.preguntaSeleccionada.iNumPreg,
      iNumGuia: 0,
      sTexto: "",
      sTabla: "",
      sTipo: "",
      sCampo: ""
    };

    this.cuestionariosService.getGuiones(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.guiones = response.data;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los guiones'
          });
        }
      },
      error: (error) => {
        console.error('Error al cargar guiones:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron cargar los guiones'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openNew(): void {
    this.guionSeleccionado = null;
    this.displayNuevoGuionDialog = true;
  }

  editGuion(guion: any): void {
    console.log('Editando guión:', guion);
    this.guionSeleccionado = { ...guion }; // Crear una copia del guión
    this.displayNuevoGuionDialog = true;
  }

  deleteGuion(guion: any): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este guión?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        const request = {
          que: 3,
          sClaveCues: this.cuestionario.sClaveCues,
          iNumPreg: this.preguntaSeleccionada.iNumPreg,
          iNumGuia: guion.iNumGuia,
          sTexto: "",
          sTabla: "",
          sTipo: "",
          sCampo: ""
        };

        this.cuestionariosService.guardarGuion(request).subscribe({
          next: (response) => {
            if (response.success && response.data.error === "0") {
              Swal.fire(
                '¡Eliminado!',
                'El guión ha sido eliminado correctamente.',
                'success'
              );
              this.cargarGuiones();
            } else {
              Swal.fire(
                'Error',
                'No se pudo eliminar el guión.',
                'error'
              );
            }
          },
          error: (error) => {
            console.error('Error al eliminar guión:', error);
            Swal.fire(
              'Error',
              'No se pudo eliminar el guión.',
              'error'
            );
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }

  onNuevoGuionDialogClosed(event: {refresh: boolean}): void {
    this.displayNuevoGuionDialog = false;
    this.guionSeleccionado = null;
    if (event.refresh) {
      this.cargarGuiones();
    }
  }
} 